import type * as CSS from 'csstype';
import { useParticipant } from 'core';
import { Avatar } from 'features/Avatar/Avatar';
import { ParticipantPresenterProps } from 'features/ParticipantItem/types';
import { RaiseHandIcon } from 'features/RaiseHand';
import { useRaiseHand } from 'features/RaiseHand/hooks/useRaiseHand';
import { useSIPParticipant } from 'useCase/SIPTelephony/useSIPParticipant';
import { ParticipantBar } from '../../components/ParticipantBar';
import { useParticipantItem, OrientationEnum } from '../../hooks/useParticipantItem';
import { MobileSpeakerPlaceholder, MobileSpeakerVideoRenderer, SIPCallIcon } from './view';

export const MobileSpeakerSIP = ({
    isAudioMuted,
    isVideoEnabled,
    isShowPulseAnimation,
    participant,
    onSizeChanged,
}: ParticipantPresenterProps) => {
    const { cameraPublication, isLocal } = useParticipant(participant);
    const { getObjectFit } = useParticipantItem();

    const objectFit: CSS.Properties['objectFit'] = getObjectFit(
        OrientationEnum.Portrait,
        cameraPublication?.dimensions,
    );
    const track = cameraPublication?.track;
    const isShowVideo = isVideoEnabled && track;

    const { getSIPParticipantName } = useSIPParticipant();
    const name = getSIPParticipantName(participant);

    const { checkIsHandRaised } = useRaiseHand();
    const handRaised = checkIsHandRaised(participant);

    return (
        <>
            {isShowVideo && track ? (
                <MobileSpeakerVideoRenderer
                    track={track}
                    isLocal={isLocal}
                    $objectFit={objectFit}
                    participantId={participant.identity}
                    onSizeChanged={onSizeChanged}
                />
            ) : (
                <Avatar
                    participant={participant}
                    PresenterPlaceholder={MobileSpeakerPlaceholder}
                    isShowPulseAnimation={isShowPulseAnimation}
                >
                    <SIPCallIcon icon="icCall" $speaker />
                </Avatar>
            )}

            <ParticipantBar isAudioMuted={isAudioMuted} name={name} />
            {handRaised && <RaiseHandIcon />}
        </>
    );
};
